import React from 'react';

const DefaultContainerWrapper = ({children}) =>
  <div className="row">
    <div className="template-item col-md-12">
    	
      { children }
    </div>
  </div>;

export default DefaultContainerWrapper;



// WEBPACK FOOTER //
// ./src/component/Page/DefaultContentWrapper.jsx